import { render, staticRenderFns } from "./addWiAdvanceAccount.vue?vue&type=template&id=1394ff62&lang=pug"
import script from "./addWiAdvanceAccount.vue?vue&type=script&lang=js"
export * from "./addWiAdvanceAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports